import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { take } from 'rxjs/operators';
import { MatIconModule } from '@angular/material/icon';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { VariableMenuDialogComponent } from '../../dialogs/variable-menu-dialog/variable-menu-dialg.component';
import { Observable } from 'rxjs';

export interface VariableMenuItemSettings {
  // By default the replacement tag is surrounded by '{{' and '}}' so that templates µs can interpolate them. This
  // flag turns that off
  shouldNotSurroundWithCurlyBraces?: boolean;
}
export interface VariableMenuItem {
  textKey: string;
  // VariableMenuItems either have a replacement tag (if they are a leaf) or subItems if they are just part of a branch
  replacementTag: string;
  subItems$?: Observable<VariableMenuItem[]>;
  settings?: VariableMenuItemSettings; //Not sure if settings is requried on the VariableMenuItem or just the category
}

@Component({
  imports: [CommonModule, MatIconModule, GalaxyTooltipModule, TranslateModule],
  selector: 'automata-variable-menu',
  template: `
    <mat-icon
      class="dynamic-content-icon"
      aria-label="dynamic-content"
      (click)="openDialog()"
      [glxyTooltip]="'HTML_EDITOR.DYNAMIC_CONTENT.INSERT_DYNAMIC_CONTENT' | translate"
    >
      data_object
    </mat-icon>
  `,
  styles: [
    `
      :host {
        padding-right: 16px;
        display: flex;
        align-items: center;
      }
      .dynamic-content-icon {
        margin-left: 12px;
        opacity: 0.5;
        cursor: pointer;
      }
    `,
  ],
})
export class VariableMenuComponent {
  @Output() variableSelected: EventEmitter<string> = new EventEmitter<string>();
  @Input() partnerId: string;
  @Input() extraMenuItems: VariableMenuItem[] = [];

  constructor(private dialog: MatDialog) {}

  openDialog(): void {
    const dialogRef = this.dialog.open(VariableMenuDialogComponent, {
      width: '450px',
      height: '600px',
      data: {
        namespace: this.partnerId,
        menuItems: this.extraMenuItems,
      },
    });
    dialogRef
      .afterClosed()
      .pipe(take(1))
      .subscribe((res) => {
        if (res) {
          this.variableSelected.emit(res);
        }
      });
  }
}
